import ClientSummary from '../../../../../packages/bk-web-app/client-details/ClientSummary';

export default ClientSummary;
